import React from 'react';
import RACES from '../../data/races';
import SKILLS from '../../data/skills';
import { btnStyle } from '../../styles/theme';
import { ABILITY_COST } from '../../config/gameConfig';
import SectionHeader from '../ui/SectionHeader';

// ─── TIER ABILITIES DATA ────────────────────────────────────────────────────
// TODO: Extract to src/data/tierAbilities.js in future refactor

const RACE_TIER_ABILITIES = {
  angile: {
    tier2: {
      requirement: "two_stats_20",
      options: [
        { id: "revive", name: "Revive", desc: "Revive a recently deceased character. Costs 8 Current Magic." },
        { id: "battle_mage", name: "Battle Mage", desc: "Spend 1 Current Magic to negate Armor Detriments to a Magic Check." }
      ]
    },
    tier3: {
      requirement: "two_stats_40",
      options: {
        revive: [
          { id: "healing_aura", name: "Healing Aura", desc: "Regenerate Magic now uses D8s, and can be used in combat." },
          { id: "generator", name: "Generator", desc: "Healing Magic can be used as a Free Action." }
        ],
        battle_mage: [
          { id: "front_line_mage", name: "Front Line Mage", desc: "Can now use Magic during Berserk." },
          { id: "rage", name: "Rage", desc: "All offensive Magic Power goes up a die face." }
        ]
      }
    }
  },
  avice: {
    tier2: {
      requirement: "two_stats_20",
      options: [
        { id: "life_giver", name: "Life Giver", desc: "Touch of Life now works at a 1:6 ratio." },
        { id: "well_rounded", name: "Well Rounded", desc: "All Perks jump from +2 to +5." }
      ]
    },
    tier3: {
      requirement: "two_stats_40",
      options: {
        life_giver: [
          { id: "imbuement", name: "Imbuement", desc: "Any healing done to others adds your Magic Power number in flat healing." },
          { id: "life_leech", name: "Life Leech", desc: "Touch of Life can now be used to steal Health Points, at a 1:3 ratio." }
        ],
        well_rounded: [
          { id: "magical_aura", name: "Magical Aura", desc: "Replace all Perks' +5 with Advantage on those Skills." },
          { id: "specialist", name: "Specialist", desc: "Magic Schools have a maximum Level of 15." }
        ]
      }
    }
  },
  bathla: {
    tier2: {
      requirement: "two_stats_20",
      options: [
        { id: "blades_of_fury", name: "Blades of Fury", desc: "All small weapons and Natural Blades go up a die face." },
        { id: "magic_flow", name: "Magic Flow", desc: "When Combination Casting with Water Magic, use bonuses to Water Magic instead of the lower." }
      ]
    },
    tier3: {
      requirement: "two_stats_40",
      options: {
        blades_of_fury: [
          { id: "needle_point", name: "Needle Point", desc: "Natural weapons now have the Sharp Weapon Ability." },
          { id: "precise", name: "Precise", desc: "Speed Modifier dice go up a die face." }
        ],
        magic_flow: [
          { id: "riptide", name: "Riptide", desc: "Water Magic can be used as a Movement Action." },
          { id: "flow_mastery", name: "Flow Mastery", desc: "Gain Advantage on all Water Tree Magics." }
        ]
      }
    }
  },
  bhantor: {
    tier2: {
      requirement: "two_stats_20",
      options: [
        { id: "dual_wield_large", name: "Dual Wield Large Weapons", desc: "With a large weapon in either hand, make two attacks in one Action. The second attack does not get Might Modifier dice." },
        { id: "overcharged_strike", name: "Overcharged Strike", desc: "Power Strike now uses D6s instead of D4s." }
      ]
    },
    tier3: {
      requirement: "two_stats_40",
      options: {
        dual_wield_large: [
          { id: "ultimate_proficiency", name: "Ultimate Proficiency", desc: "Second attack now gets Might Modifier dice." },
          { id: "hooligan", name: "Hooligan", desc: "Improvised weapons can now be dual wielded." }
        ],
        overcharged_strike: [
          { id: "colossus_power", name: "Colossus Power", desc: "All Might Modifier, Brawl, and Power Strike dice go up a die face." },
          { id: "colossus_regen", name: "Colossus Regeneration", desc: "Double the amount of Regeneration dice (4x Might Modifier per day)." }
        ]
      }
    }
  },
  cregex: {
    tier2: {
      requirement: "two_stats_20",
      options: [
        { id: "geode_crystals", name: "Geode Crystals", desc: "Magic costs 1 less to cast, with a minimum of 1." },
        { id: "tough_rocks", name: "Tough Rocks", desc: "Natural Armor now provides 6 AR." }
      ]
    },
    tier3: {
      requirement: "two_stats_40",
      options: {
        geode_crystals: [
          { id: "mana_crystals", name: "Mana Crystals", desc: "Twice per in-game day, restore Current Magic to Full." },
          { id: "crystal_skin", name: "Crystal Skin", desc: "Natural Armor also grants 2 MAR." }
        ],
        tough_rocks: [
          { id: "unbreakable", name: "Unbreakable", desc: "All damage is reduced by an additional 3." },
          { id: "tough_shell", name: "Tough Shell", desc: "Natural Armor now provides 8 AR." }
        ]
      }
    }
  },
  elvan: {
    tier2: {
      requirement: "two_stats_20",
      options: [
        { id: "vines", name: "Vines", desc: "Vines can now reach 3x your Might Modifier in Steps and counts as a free action." },
        { id: "flora_friend", name: "Flora Friend", desc: "Learn all Elemental Magic at Level 1, or if you already know it, it increases by 1." }
      ]
    },
    tier3: {
      requirement: "two_stats_40",
      options: {
        vines: [
          { id: "forest_companion", name: "Forest Companion", desc: "Vines can now be used offensively, with a damage die of 1D6." },
          { id: "entangle", name: "Entangle", desc: "Can use vines to grapple, Vine range is now 5x Might Modifier." }
        ],
        flora_friend: [
          { id: "flora_master", name: "Flora Master", desc: "All Earth and Elemental Magic now have Advantage." },
          { id: "nature_resistance", name: "Nature Resistance", desc: "Resistance to all Nature and Elemental damage." }
        ]
      }
    }
  },
  galatine: {
    tier2: {
      requirement: "two_stats_20",
      options: [
        { id: "sharpshooter", name: "Sharpshooter", desc: "Range bonus is 1.5x Modifier instead of 1x." },
        { id: "dash", name: "Dash", desc: "Gain an additional Movement Action." }
      ]
    },
    tier3: {
      requirement: "two_stats_40",
      options: {
        sharpshooter: [
          { id: "headshot", name: "Headshot", desc: "All ranged weapon damage dice go up a die face." },
          { id: "quickdraw", name: "Quickdraw", desc: "Can draw a weapon as a free action. If drawing a ranged weapon, gain Advantage on the first attack." }
        ],
        dash: [
          { id: "lightning_speed", name: "Lightning Speed", desc: "Speed Modifier dice go up a die face." },
          { id: "wind_walker", name: "Wind Walker", desc: "Movement does not provoke opportunity attacks." }
        ]
      }
    }
  },
  inamorite: {
    tier2: {
      requirement: "two_stats_20",
      options: [
        { id: "inspiring_presence", name: "Inspiring Presence", desc: "Allies within line of sight gain +2 to all checks." },
        { id: "divine_channeling", name: "Divine Channeling", desc: "All Light Magic costs 1 less Magic, minimum 1." }
      ]
    },
    tier3: {
      requirement: "two_stats_40",
      options: {
        inspiring_presence: [
          { id: "commanders_aura", name: "Commander's Aura", desc: "Inspiring Presence now grants Advantage instead of +2." },
          { id: "rally", name: "Rally", desc: "Once per encounter, all allies regain Current Health equal to your Intellect Modifier." }
        ],
        divine_channeling: [
          { id: "holy_power", name: "Holy Power", desc: "All Light Magic damage dice go up a die face." },
          { id: "divine_protection", name: "Divine Protection", desc: "Gain resistance to Dark and Necrotic damage." }
        ]
      }
    }
  },
  korvax: {
    tier2: {
      requirement: "two_stats_20",
      options: [
        { id: "feral_rage", name: "Feral Rage", desc: "Berserk Mode dice go up a die face." },
        { id: "pack_tactics", name: "Pack Tactics", desc: "Gain Advantage on melee attacks if an ally is within 5 Steps of target." }
      ]
    },
    tier3: {
      requirement: "two_stats_40",
      options: {
        feral_rage: [
          { id: "primal_fury", name: "Primal Fury", desc: "Berserk Mode now lasts until combat ends." },
          { id: "savage", name: "Savage", desc: "Critical hits in Berserk Mode deal maximum damage." }
        ],
        pack_tactics: [
          { id: "alpha", name: "Alpha", desc: "Allies gain +1 to melee attack rolls while within 10 Steps of you." },
          { id: "coordinated_strike", name: "Coordinated Strike", desc: "Once per turn, an ally within 10 Steps can make an opportunity attack when you hit." }
        ]
      }
    }
  },
  ludite: {
    tier2: {
      requirement: "two_stats_20",
      options: [
        { id: "tech_savant", name: "Tech Savant", desc: "Advantage on all Technology and Craft checks." },
        { id: "gadgeteer", name: "Gadgeteer", desc: "Can create one gadget per day that grants +3 to a specific skill check." }
      ]
    },
    tier3: {
      requirement: "two_stats_40",
      options: {
        tech_savant: [
          { id: "master_crafter", name: "Master Crafter", desc: "Created items have double durability and effectiveness." },
          { id: "innovation", name: "Innovation", desc: "Can jury-rig solutions to problems, DM discretion on effects." }
        ],
        gadgeteer: [
          { id: "multi_tool", name: "Multi-Tool", desc: "Create up to 3 gadgets per day instead of 1." },
          { id: "explosive_expert", name: "Explosive Expert", desc: "Created explosives deal an additional 2D6 damage." }
        ]
      }
    }
  },
  moridan: {
    tier2: {
      requirement: "two_stats_20",
      options: [
        { id: "shadow_step", name: "Shadow Step", desc: "Teleport up to 2x your Speed Modifier in Steps as a Movement Action while in darkness." },
        { id: "night_vision", name: "Night Vision", desc: "Perfect vision in darkness. Gain Advantage on Stealth checks in dim light or darkness." }
      ]
    },
    tier3: {
      requirement: "two_stats_40",
      options: {
        shadow_step: [
          { id: "shadow_strike", name: "Shadow Strike", desc: "Attacks made immediately after Shadow Step have Advantage and deal +1D8 damage." },
          { id: "dark_form", name: "Dark Form", desc: "Can become incorporeal in darkness for up to 1 minute per day." }
        ],
        night_vision: [
          { id: "assassin", name: "Assassin", desc: "Critical hit range increases to 18-20 when attacking from stealth." },
          { id: "shadow_cloak", name: "Shadow Cloak", desc: "Invisible in darkness unless you attack or are touched." }
        ]
      }
    }
  },
  myrin: {
    tier2: {
      requirement: "two_stats_20",
      options: [
        { id: "elemental_attunement", name: "Elemental Attunement", desc: "Choose one element. All magic of that element deals +1D6 damage." },
        { id: "spell_weaver", name: "Spell Weaver", desc: "Can combine two spells into one action, both cost full Magic." }
      ]
    },
    tier3: {
      requirement: "two_stats_40",
      options: {
        elemental_attunement: [
          { id: "elemental_mastery", name: "Elemental Mastery", desc: "Chosen element's magic damage dice go up a die face." },
          { id: "elemental_immunity", name: "Elemental Immunity", desc: "Immune to damage from your chosen element." }
        ],
        spell_weaver: [
          { id: "arcane_surge", name: "Arcane Surge", desc: "Once per day, cast any spell without spending Magic." },
          { id: "metamagic", name: "Metamagic", desc: "Can modify spell effects (increase range, area, or duration by 50%)." }
        ]
      }
    }
  },
  serevan: {
    tier2: {
      requirement: "two_stats_20",
      options: [
        { id: "aquatic_adaptation", name: "Aquatic Adaptation", desc: "Swim speed equals movement speed. Can breathe underwater indefinitely." },
        { id: "tidal_force", name: "Tidal Force", desc: "Water Magic deals +2D6 damage and can push targets 2D6 Steps." }
      ]
    },
    tier3: {
      requirement: "two_stats_40",
      options: {
        aquatic_adaptation: [
          { id: "pressure_resistance", name: "Pressure Resistance", desc: "Immune to water pressure. Can fight underwater without penalties." },
          { id: "water_form", name: "Water Form", desc: "Turn into water for 1 minute per day, immune to physical damage." }
        ],
        tidal_force: [
          { id: "tsunami", name: "Tsunami", desc: "Water Magic affects a 30-Step cone instead of single target." },
          { id: "water_mastery", name: "Water Mastery", desc: "All Water Magic has Advantage and costs 2 less Magic (minimum 1)." }
        ]
      }
    }
  }
};

const ALCHEMY_ABILITIES = {
  tier1: {
    requirement: 3,
    options: [
      { id: "brew_health", name: "Brew Health Potion", desc: "Create health potions that restore 2D6 + Intellect Modifier HP." },
      { id: "brew_mana", name: "Brew Mana Potion", desc: "Create mana potions that restore 2D6 + Intellect Modifier Magic." },
      { id: "brew_antidote", name: "Brew Antidote", desc: "Create antidotes that cure poisons and diseases." },
      { id: "brew_explosive", name: "Brew Explosive", desc: "Create alchemical explosives dealing 3D6 fire damage in 10-Step radius." }
    ]
  },
  tier2: {
    requirement: 5,
    options: [
      { id: "greater_potions", name: "Greater Potions", desc: "Health and Mana potions now restore 4D6 + (2x Intellect Modifier)." },
      { id: "lingering_effects", name: "Lingering Effects", desc: "All alchemical effects last 50% longer." },
      { id: "bulk_brewing", name: "Bulk Brewing", desc: "Create 3 potions for the cost of resources for 1." },
      { id: "volatile_compounds", name: "Volatile Compounds", desc: "Explosives now deal 5D6 damage in 15-Step radius." }
    ]
  },
  tier3: {
    requirement: 7,
    options: [
      { id: "transmutation", name: "Transmutation", desc: "Can transmute common materials into rare ones (DM discretion)." },
      { id: "philosophers_stone", name: "Philosopher's Stone", desc: "Create a stone that grants +2 to all stats for 1 hour (once per day)." },
      { id: "elixir_of_life", name: "Elixir of Life", desc: "Create an elixir that brings someone back from death if used within 1 minute." },
      { id: "alchemical_mastery", name: "Alchemical Mastery", desc: "All Alchemy checks have Advantage. Potion effects doubled." }
    ]
  }
};

const STAT_TIER_ABILITIES = {
  might: {
    tier1: {
      requirement: 20,
      options: [
        { id: "charge", name: "Charge", prerequisite: "Athletics lvl 5", desc: "Charge forward with up to full movement speed in a straight line and make an attack. Upon success, add Athletics level in flat damage." },
        { id: "extension", name: "Extension", prerequisite: "Athletics lvl 5", desc: "Spend Current Might to deal extra damage. For each Health Point spent, deal 2 damage." },
        { id: "guard_break", name: "Guard Break", prerequisite: "Recover lvl 5", desc: "If an attack is blocked, attack again with an added D4 to the attack roll." },
        { id: "heavy_hands", name: "Heavy Hands", prerequisite: "Brawl lvl 5", desc: "Add Minor AR to Brawl attacks as flat damage." },
        { id: "might_grapple", name: "Might Grapple", prerequisite: "Brawl lvl 5", desc: "Use the Brawl Skill to grapple." },
        { id: "shield_bash", name: "Shield Bash", prerequisite: "Block lvl 5", desc: "Use the Block Skill to attack with a shield. Deal the shields AR in damage plus Modifier dice." },
        { id: "pushback", name: "Pushback", prerequisite: "Block lvl 5", desc: "Use offensive Might Actions to deal Status Effects instead of damage." },
        { id: "war_cry", name: "War Cry", prerequisite: "Intimidate lvl 5", desc: "Use Inspiration as if it were a Might Skill." }
      ]
    },
    tier2: {
      requirement: 30,
      options: [
        { id: "absorption", name: "Absorption", prerequisite: "Brawl and Constitution lvl 7, Heavy Hands", desc: "Add Major AR instead of Minor AR to Brawl attacks as flat damage." },
        { id: "berserk", name: "Berserk", prerequisite: "Athletics and Brawl lvl 7", desc: "While active, character deals double damage. Character may only move and use Might based actions. Character cannot defend." },
        { id: "follow_through", name: "Follow Through", prerequisite: "Athletics and Large Weapons lvl 7", desc: "Attacks with Large Weapons can hit additional targets within reach, dealing half the damage of the last adjacent target hit." },
        { id: "mastercraft", name: "Mastercraft", prerequisite: "Craft and Constitution lvl 7", desc: "Gain the ability to Mastercraft a single category of weapons or armor. Mastercrafting items takes substantial time." },
        { id: "riposte", name: "Riposte", prerequisite: "Brawl and Large Weapons lvl 7", desc: "After successfully blocking with a weapon, gain an attack of opportunity at half damage." },
        { id: "shield_bearer", name: "Shield Bearer", prerequisite: "Block and Constitution lvl 7", desc: "All shields gain Might Modifier in AR." },
        { id: "shield_reflex", name: "Shield Reflex", prerequisite: "Block and Recover lvl 7, Shield Bash", desc: "Use Shield Bash upon successful Block." }
      ]
    },
    tier3: {
      requirement: 50,
      options: [
        { id: "resilience", name: "Resilience", prerequisite: "Berserk", desc: "No longer take penalties for having zero in any Stat." },
        { id: "master_craftsman", name: "Master Craftsman", prerequisite: "Mastercraft", desc: "Gain a second Mastercraft with the option to purchase a third." }
      ]
    }
  },
  speed: {
    tier1: {
      requirement: 20,
      options: [
        { id: "armor_training", name: "Armor Training", prerequisite: "Initiative lvl 5", desc: "Remove Armor Detriments to Speed Skills except for Escape, Sneak, and Sleight of Hand. Does not remove Detriment from shields." },
        { id: "backstab", name: "Backstab", prerequisite: "Sneak lvl 5", desc: "Attacks while hidden have Advantage." },
        { id: "dash", name: "Dash", prerequisite: "Balance lvl 5", desc: "When using your action to move, you can still attack a single target for half your rolled damage. Gain half of your Speed Modifier to Movement." },
        { id: "first_strike", name: "First Strike", prerequisite: "Initiative lvl 5", desc: "Gain half of Speed Modifier to Movement. When first in initiative, add an additional weapon damage die. Gain attacks of opportunity when a target leaves your reach." },
        { id: "minimum_damage", name: "Minimum Damage", prerequisite: "Sleight of Hand lvl 5", desc: "When a 1 is rolled on a damage die, you may keep the roll, reroll the die, and add the new roll to the existing total. Usable up to your Speed Modifier per die. This Ability only applies to weapons." },
        { id: "sharpshot", name: "Sharpshot", prerequisite: "Range lvl 5", desc: "Ranged flat damage is doubled." },
        { id: "speed_grapple", name: "Speed Grapple", prerequisite: "Escape lvl 5", desc: "Use Sleight of Hand to grapple." },
        { id: "precise_hit", name: "Precise Hit", prerequisite: "Sneak lvl 5", desc: "When a 1 is rolled on a damage die it becomes: D4: 2, D6: 3, D8: 4, D10: 5, D12: 6, D20: 10." }
      ]
    },
    tier2: {
      requirement: 30,
      options: [
        { id: "dual_wield", name: "Dual Wield", prerequisite: "Balance and Small Weapons lvl 7", desc: "Gain an additional Small Weapons attack using an off hand weapon." },
        { id: "martial_artist", name: "Martial Artist", prerequisite: "Balance lvl 7 and Initiative lvl 7", desc: "When an opponent tries to attack with Melee, Grapple, or Brawl, you may roll Balance as a defense and knock them Prone if you succeed." },
        { id: "double_shot", name: "Double Shot", prerequisite: "Range and Sleight of Hand lvl 7", desc: "If you land an attack with a ranged weapon, you double your damage and the target gets double their AR." },
        { id: "swift", name: "Swift", prerequisite: "Balance and Sleight of Hand lvl 7", desc: "During Movement, deal half damage with a single primary attack to any/all enemies you pass. If a character also has Dash, damage is increased to full." }
      ]
    },
    tier3: {
      requirement: 50,
      options: [
        { id: "nimble", name: "Nimble", prerequisite: "Swift", desc: "Gain Advantage on non-combat Speed Skill Checks." },
        { id: "reflex", name: "Reflex", prerequisite: "Martial Artist", desc: "A successful defense grants you an additional Movement Action." }
      ]
    }
  },
  intellect: {
    tier1: {
      requirement: 20,
      options: [
        { id: "aim", name: "Aim", prerequisite: "Perception lvl 5", desc: "Sacrifice Movement to add +2 to hit." },
        { id: "effort", name: "Effort", prerequisite: "Intuition lvl 5", desc: "Spend Current Stat points to increase the chance of success on a roll. For each point spent, up to double Modifier, to gain +1 to your roll." },
        { id: "focus", name: "Focus", prerequisite: "Intuition lvl 5", desc: "When Current Might or Speed reaches 0 and Intellect is half, double all damage types." },
        { id: "meditate", name: "Meditate", prerequisite: "Knowledge lvl 5", desc: "Rest anywhere outside of combat to regain 1D6 of Health; usable up to double your Intellect Modifier per in-game day." },
        { id: "overcharge", name: "Overcharge", prerequisite: "Knowledge lvl 5", desc: "Sacrifice a turn or take half of your Magic Power in Intellect damage in order to increase magic a die face. Up to 3 times per cast using this method." },
        { id: "snide", name: "Snide", prerequisite: "Persuasion lvl 5", desc: "Use Intimidate as if it were an Intellect Skill." }
      ]
    },
    tier2: {
      requirement: 30,
      options: [
        { id: "anticipation", name: "Anticipation", prerequisite: "Inspiration and Intuition lvl 7", desc: "Spend 3 Current Intellect to gain Advantage on your next roll." },
        { id: "crit_range", name: "Crit Range", prerequisite: "Identify and Perception lvl 7", desc: "Increase the critical range from 20 to 19-20." },
        { id: "magic_shielding", name: "Magic Shielding", prerequisite: "Intuition and Magic Reflex lvl 7", desc: "Magic Reflex can be used to negate physical damage as well as Magical." },
        { id: "magic_training", name: "Magic Training", prerequisite: "Knowledge and Intuition lvl 7", desc: "Add Intellect Modifier to Magic Schools." }
      ]
    },
    tier3: {
      requirement: 50,
      options: [
        { id: "prodigy", name: "Prodigy", prerequisite: "Crit Range", desc: "Decrease cost of everything by 1 EXP." },
        { id: "tactics", name: "Tactics", prerequisite: "Anticipation", desc: "Once per encounter, before an oncoming attack is rolled, choose to avoid all damage." }
      ]
    }
  }
};

// ─── HELPER FUNCTIONS ───────────────────────────────────────────────────────

function hasTwoStatsAtLevel(stats, threshold) {
  const statValues = Object.values(stats);
  const countAtThreshold = statValues.filter(v => v >= threshold).length;
  return countAtThreshold >= 2;
}

function hasAlchemyAtLevel(alchemy, threshold) {
  const alchemyValues = Object.values(alchemy || {});
  const maxLevel = Math.max(...alchemyValues, 0);
  return maxLevel >= threshold;
}

// ─── MAIN COMPONENT ─────────────────────────────────────────────────────────

export default function TieredAbilities({ character, setCharacter, expPools, setExpPools }) {
  // State for collapsible sections - MUST be at top before any returns
  const [expandedSections, setExpandedSections] = React.useState({
    race: true,
    alchemy: true,
    might: false,
    speed: false,
    intellect: false
  });

  // Early return if character not loaded
  if (!character) {
    return <div style={{ padding: 40, textAlign: "center", color: "#8a7e5e" }}>Loading character...</div>;
  }

  const toggleSection = (section) => {
    setExpandedSections({
      ...expandedSections,
      [section]: !expandedSections[section]
    });
  };

  const race = RACES.find(r => r.id === character.race);
  const raceTierData = RACE_TIER_ABILITIES[character.race];

  // Initialize tierAbilities if not present
  if (!character.tierAbilities) {
    setCharacter({
      ...character,
      tierAbilities: {
        tier2: null,
        tier3: null,
        alchemyTier1: [],
        alchemyTier2: [],
        alchemyTier3: [],
        mightTier1: [],
        mightTier2: [],
        mightTier3: [],
        speedTier1: [],
        speedTier2: [],
        speedTier3: [],
        intellectTier1: [],
        intellectTier2: [],
        intellectTier3: []
      }
    });
    return <div style={{ padding: 40, textAlign: "center", color: "#8a7e5e" }}>Initializing abilities...</div>;
  }

  // Purchase functions
  function purchaseRaceTier2(abilityId) {
    if (expPools.universal < ABILITY_COST) return;
    setExpPools({ ...expPools, universal: expPools.universal - ABILITY_COST });
    setCharacter({ 
      ...character, 
      tierAbilities: { ...character.tierAbilities, tier2: abilityId }
    });
  }

  function purchaseRaceTier3(abilityId) {
    if (expPools.universal < ABILITY_COST) return;
    setExpPools({ ...expPools, universal: expPools.universal - ABILITY_COST });
    setCharacter({ 
      ...character, 
      tierAbilities: { ...character.tierAbilities, tier3: abilityId }
    });
  }

  function purchaseAlchemyAbility(tier, abilityId) {
    if (expPools.universal < ABILITY_COST && expPools.intellect < ABILITY_COST) return;
    
    const tierKey = `alchemyTier${tier}`;
    if (character.tierAbilities[tierKey].includes(abilityId)) return;

    // Deduct EXP
    if (expPools.universal >= ABILITY_COST) {
      setExpPools({ ...expPools, universal: expPools.universal - ABILITY_COST });
    } else {
      setExpPools({ ...expPools, intellect: expPools.intellect - ABILITY_COST });
    }

    // Add ability
    setCharacter({
      ...character,
      tierAbilities: {
        ...character.tierAbilities,
        [tierKey]: [...character.tierAbilities[tierKey], abilityId]
      }
    });
  }

  function purchaseStatAbility(stat, tier, abilityId) {
    if (expPools.universal < ABILITY_COST && expPools[stat] < ABILITY_COST) return;
    
    const tierKey = `${stat}Tier${tier}`;
    if (character.tierAbilities[tierKey].includes(abilityId)) return;

    // Deduct EXP
    if (expPools.universal >= ABILITY_COST) {
      setExpPools({ ...expPools, universal: expPools.universal - ABILITY_COST });
    } else {
      setExpPools({ ...expPools, [stat]: expPools[stat] - ABILITY_COST });
    }

    // Add ability
    setCharacter({
      ...character,
      tierAbilities: {
        ...character.tierAbilities,
        [tierKey]: [...character.tierAbilities[tierKey], abilityId]
      }
    });
  }

  // Check if skill prerequisites are met
  function hasSkillPrerequisite(prerequisite) {
    if (!prerequisite) return true;
    
    // Parse prerequisite string (e.g., "Athletics lvl 5", "Brawl and Constitution lvl 7")
    const parts = prerequisite.split(/ and |, /i);
    
    return parts.every(part => {
      const match = part.match(/([\w\s]+)\s+lvl\s+(\d+)/i);
      if (!match) {
        // Check for ability prerequisites like "Heavy Hands" or "Shield Bash"
        return true; // If not a skill level requirement, assume met
      }
      
      const skillNameFromPrereq = match[1].trim().toLowerCase();
      const requiredLevel = parseInt(match[2]);
      
      // Find skill ID from SKILLS data
      const allSkills = [...SKILLS.might, ...SKILLS.speed, ...SKILLS.intellect];
      const skill = allSkills.find(s => {
        const skillNameLower = s.name.toLowerCase();
        // Try exact match first
        if (skillNameLower === skillNameFromPrereq) return true;
        // Try if skill name contains the prerequisite
        if (skillNameLower.includes(skillNameFromPrereq)) return true;
        // Try if prerequisite contains the skill name (for multi-word skills)
        if (skillNameFromPrereq.includes(skillNameLower)) return true;
        return false;
      });
      
      if (!skill) {
        console.warn(`Skill not found for prerequisite: "${skillNameFromPrereq}"`);
        return false; // Skill not found, requirement not met
      }
      
      const currentLevel = character.skills[skill.id] || 0;
      return currentLevel >= requiredLevel;
    });
  }

  // Check if ability prerequisite is met (for tier 3 abilities)
  function hasAbilityPrerequisite(stat, tier, prerequisite) {
    if (!prerequisite) return true;
    
    // Check if prerequisite ability is owned
    const tierKey = `${stat}Tier${tier}`;
    const prevTierKey = `${stat}Tier${tier - 1}`;
    
    // Find the prerequisite ability ID
    const prevTierAbilities = STAT_TIER_ABILITIES[stat][`tier${tier - 1}`].options;
    const prereqAbility = prevTierAbilities.find(a => a.name === prerequisite);
    
    if (!prereqAbility) return true; // Prerequisite not found, assume met
    
    return character.tierAbilities[prevTierKey].includes(prereqAbility.id);
  }

  function resetTierAbilities() {
    setCharacter({
      ...character,
      tierAbilities: {
        tier2: null,
        tier3: null,
        alchemyTier1: [],
        alchemyTier2: [],
        alchemyTier3: [],
        mightTier1: [],
        mightTier2: [],
        mightTier3: [],
        speedTier1: [],
        speedTier2: [],
        speedTier3: [],
        intellectTier1: [],
        intellectTier2: [],
        intellectTier3: []
      }
    });
  }

  // Check requirements
  const tier2Unlocked = hasTwoStatsAtLevel(character.stats, 20);
  const tier3Unlocked = hasTwoStatsAtLevel(character.stats, 40) && character.tierAbilities.tier2;
  
  const alchemyTier1Unlocked = hasAlchemyAtLevel(character.alchemy, 3);
  const alchemyTier2Unlocked = hasAlchemyAtLevel(character.alchemy, 5);
  const alchemyTier3Unlocked = hasAlchemyAtLevel(character.alchemy, 7);

  return (
    <div style={{ position: "relative", zIndex: 1, maxWidth: 820, margin: "0 auto", padding: "0 16px 40px" }}>
      <SectionHeader>Tiered Abilities</SectionHeader>

      {/* Reset Button */}
      <div style={{ textAlign: "center", marginBottom: 24 }}>
        <button
          onClick={resetTierAbilities}
          style={{ ...btnStyle("#c0392b", "rgba(192,57,43,0.15)"), padding: "8px 16px" }}
        >
          Reset Abilities
        </button>
      </div>

      {/* Race Tier Abilities */}
      <div style={{
        background: "rgba(20,16,10,0.6)",
        border: "1px solid rgba(201,168,76,0.3)",
        borderRadius: 8,
        padding: 20,
        marginBottom: 24
      }}>
        <h3 style={{ color: "#c9a84c", marginBottom: 4, fontSize: 18 }}>Race Abilities - {race?.name}</h3>
        <p style={{ color: "#8a7e5e", fontSize: 12, marginBottom: 16 }}>
          Tier 2: Requires any 2 stats at 20+ • Tier 3: Requires any 2 stats at 40+ and a Tier 2 choice
        </p>

        {/* Tier 2 */}
        <div style={{ marginBottom: 20 }}>
          <div style={{
            color: tier2Unlocked ? "#16a085" : "#6b6048",
            fontSize: 14,
            marginBottom: 12,
            display: "flex",
            alignItems: "center",
            gap: 8
          }}>
            <span>Tier 2</span>
            {!tier2Unlocked && <span style={{ fontSize: 11, color: "#c0392b" }}>(Locked - Need 2 stats at 20+)</span>}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: 12 }}>
            {raceTierData.tier2.options.map(ability => {
              const isOwned = character.tierAbilities.tier2 === ability.id;
              const canBuy = tier2Unlocked && !character.tierAbilities.tier2 && expPools.universal >= ABILITY_COST;

              return (
                <div key={ability.id} style={{
                  background: isOwned ? "rgba(22,160,133,0.15)" : "rgba(0,0,0,0.3)",
                  border: isOwned ? "1px solid #16a085" : "1px solid rgba(22,160,133,0.2)",
                  borderRadius: 6,
                  padding: 12
                }}>
                  <div style={{ 
                    color: isOwned ? "#16a085" : "#5dade2", 
                    fontSize: 13,
                    marginBottom: 4,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}>
                    <span>{ability.name}</span>
                    <span style={{ fontSize: 11, color: "#8a7e5e" }}>{ABILITY_COST} EXP</span>
                  </div>
                  <p style={{ color: "#a09070", fontSize: 11, marginBottom: 8, lineHeight: 1.4 }}>
                    {ability.desc}
                  </p>
                  <button
                    onClick={() => canBuy && purchaseRaceTier2(ability.id)}
                    disabled={!canBuy}
                    style={{
                      ...btnStyle(isOwned ? "#16a085" : "#5dade2", isOwned ? "rgba(22,160,133,0.2)" : "rgba(22,160,133,0.1)"),
                      padding: "6px 12px",
                      width: "100%",
                      cursor: canBuy ? "pointer" : "not-allowed",
                      opacity: canBuy || isOwned ? 1 : 0.5
                    }}
                  >
                    {isOwned ? "✓ Owned" : !tier2Unlocked ? "Locked" : "Buy"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* Tier 3 */}
        {character.tierAbilities.tier2 && (
          <div>
            <div style={{
              color: tier3Unlocked ? "#2980b9" : "#6b6048",
              fontSize: 14,
              marginBottom: 12,
              display: "flex",
              alignItems: "center",
              gap: 8
            }}>
              <span>Tier 3</span>
              {!tier3Unlocked && <span style={{ fontSize: 11, color: "#c0392b" }}>(Locked - Need 2 stats at 40+)</span>}
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: 12 }}>
              {raceTierData.tier3.options[character.tierAbilities.tier2].map(ability => {
                const isOwned = character.tierAbilities.tier3 === ability.id;
                const canBuy = tier3Unlocked && !character.tierAbilities.tier3 && expPools.universal >= ABILITY_COST;

                return (
                  <div key={ability.id} style={{
                    background: isOwned ? "rgba(41,128,185,0.15)" : "rgba(0,0,0,0.3)",
                    border: isOwned ? "1px solid #2980b9" : "1px solid rgba(41,128,185,0.2)",
                    borderRadius: 6,
                    padding: 12
                  }}>
                    <div style={{ 
                      color: isOwned ? "#2980b9" : "#5dade2", 
                      fontSize: 13,
                      marginBottom: 4,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}>
                      <span>{ability.name}</span>
                      <span style={{ fontSize: 11, color: "#8a7e5e" }}>{ABILITY_COST} EXP</span>
                    </div>
                    <p style={{ color: "#a09070", fontSize: 11, marginBottom: 8, lineHeight: 1.4 }}>
                      {ability.desc}
                    </p>
                    <button
                      onClick={() => canBuy && purchaseRaceTier3(ability.id)}
                      disabled={!canBuy}
                      style={{
                        ...btnStyle(isOwned ? "#2980b9" : "#5dade2", isOwned ? "rgba(41,128,185,0.2)" : "rgba(41,128,185,0.1)"),
                        padding: "6px 12px",
                        width: "100%",
                        cursor: canBuy ? "pointer" : "not-allowed",
                        opacity: canBuy || isOwned ? 1 : 0.5
                      }}
                    >
                      {isOwned ? "✓ Owned" : !tier3Unlocked ? "Locked" : "Buy"}
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {/* Alchemy Abilities */}
      <div style={{
        background: "rgba(20,16,10,0.6)",
        border: "1px solid rgba(142,68,173,0.3)",
        borderRadius: 8,
        padding: 20
      }}>
        <div 
          onClick={() => toggleSection('alchemy')}
          style={{ 
            cursor: "pointer", 
            display: "flex", 
            justifyContent: "space-between", 
            alignItems: "center",
            marginBottom: expandedSections.alchemy ? 16 : 0
          }}
        >
          <div>
            <h3 style={{ color: "#8e44ad", marginBottom: 4, fontSize: 18 }}>Alchemy Abilities</h3>
            <p style={{ color: "#8a7e5e", fontSize: 12 }}>
              Requires one Alchemy class at specified level • Uses Universal or Intellect EXP
            </p>
          </div>
          <span style={{ color: "#8e44ad", fontSize: 24 }}>
            {expandedSections.alchemy ? "−" : "+"}
          </span>
        </div>

        {expandedSections.alchemy && (
          <>

        {/* Tier 1 */}
        <div style={{ marginBottom: 20 }}>
          <div style={{
            color: alchemyTier1Unlocked ? "#16a085" : "#6b6048",
            fontSize: 14,
            marginBottom: 12,
            display: "flex",
            alignItems: "center",
            gap: 8
          }}>
            <span>Tier 1 (Class 3+)</span>
            {!alchemyTier1Unlocked && <span style={{ fontSize: 11, color: "#c0392b" }}>(Locked)</span>}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
            {ALCHEMY_ABILITIES.tier1.options.map(ability => {
              const isOwned = character.tierAbilities.alchemyTier1.includes(ability.id);
              const canBuy = alchemyTier1Unlocked && !isOwned && (expPools.universal >= ABILITY_COST || expPools.intellect >= ABILITY_COST);

              return (
                <div key={ability.id} style={{
                  background: isOwned ? "rgba(142,68,173,0.15)" : "rgba(0,0,0,0.3)",
                  border: isOwned ? "1px solid #8e44ad" : "1px solid rgba(142,68,173,0.2)",
                  borderRadius: 6,
                  padding: 12
                }}>
                  <div style={{ 
                    color: isOwned ? "#8e44ad" : "#c39bd3", 
                    fontSize: 13,
                    marginBottom: 4,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}>
                    <span>{ability.name}</span>
                    <span style={{ fontSize: 11, color: "#8a7e5e" }}>{ABILITY_COST} EXP</span>
                  </div>
                  <p style={{ color: "#a09070", fontSize: 11, marginBottom: 8, lineHeight: 1.4 }}>
                    {ability.desc}
                  </p>
                  <button
                    onClick={() => canBuy && purchaseAlchemyAbility(1, ability.id)}
                    disabled={!canBuy}
                    style={{
                      ...btnStyle(isOwned ? "#8e44ad" : "#c39bd3", isOwned ? "rgba(142,68,173,0.2)" : "rgba(142,68,173,0.1)"),
                      padding: "6px 12px",
                      width: "100%",
                      cursor: canBuy ? "pointer" : "not-allowed",
                      opacity: canBuy || isOwned ? 1 : 0.5
                    }}
                  >
                    {isOwned ? "✓ Owned" : !alchemyTier1Unlocked ? "Locked" : "Buy"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* Tier 2 */}
        <div style={{ marginBottom: 20 }}>
          <div style={{
            color: alchemyTier2Unlocked ? "#27ae60" : "#6b6048",
            fontSize: 14,
            marginBottom: 12,
            display: "flex",
            alignItems: "center",
            gap: 8
          }}>
            <span>Tier 2 (Class 5+)</span>
            {!alchemyTier2Unlocked && <span style={{ fontSize: 11, color: "#c0392b" }}>(Locked)</span>}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
            {ALCHEMY_ABILITIES.tier2.options.map(ability => {
              const isOwned = character.tierAbilities.alchemyTier2.includes(ability.id);
              const canBuy = alchemyTier2Unlocked && !isOwned && (expPools.universal >= ABILITY_COST || expPools.intellect >= ABILITY_COST);

              return (
                <div key={ability.id} style={{
                  background: isOwned ? "rgba(39,174,96,0.15)" : "rgba(0,0,0,0.3)",
                  border: isOwned ? "1px solid #27ae60" : "1px solid rgba(39,174,96,0.2)",
                  borderRadius: 6,
                  padding: 12
                }}>
                  <div style={{ 
                    color: isOwned ? "#27ae60" : "#82e0aa", 
                    fontSize: 13,
                    marginBottom: 4,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}>
                    <span>{ability.name}</span>
                    <span style={{ fontSize: 11, color: "#8a7e5e" }}>{ABILITY_COST} EXP</span>
                  </div>
                  <p style={{ color: "#a09070", fontSize: 11, marginBottom: 8, lineHeight: 1.4 }}>
                    {ability.desc}
                  </p>
                  <button
                    onClick={() => canBuy && purchaseAlchemyAbility(2, ability.id)}
                    disabled={!canBuy}
                    style={{
                      ...btnStyle(isOwned ? "#27ae60" : "#82e0aa", isOwned ? "rgba(39,174,96,0.2)" : "rgba(39,174,96,0.1)"),
                      padding: "6px 12px",
                      width: "100%",
                      cursor: canBuy ? "pointer" : "not-allowed",
                      opacity: canBuy || isOwned ? 1 : 0.5
                    }}
                  >
                    {isOwned ? "✓ Owned" : !alchemyTier2Unlocked ? "Locked" : "Buy"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* Tier 3 */}
        <div>
          <div style={{
            color: alchemyTier3Unlocked ? "#f39c12" : "#6b6048",
            fontSize: 14,
            marginBottom: 12,
            display: "flex",
            alignItems: "center",
            gap: 8
          }}>
            <span>Tier 3 (Class 7+)</span>
            {!alchemyTier3Unlocked && <span style={{ fontSize: 11, color: "#c0392b" }}>(Locked)</span>}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
            {ALCHEMY_ABILITIES.tier3.options.map(ability => {
              const isOwned = character.tierAbilities.alchemyTier3.includes(ability.id);
              const canBuy = alchemyTier3Unlocked && !isOwned && (expPools.universal >= ABILITY_COST || expPools.intellect >= ABILITY_COST);

              return (
                <div key={ability.id} style={{
                  background: isOwned ? "rgba(243,156,18,0.15)" : "rgba(0,0,0,0.3)",
                  border: isOwned ? "1px solid #f39c12" : "1px solid rgba(243,156,18,0.2)",
                  borderRadius: 6,
                  padding: 12
                }}>
                  <div style={{ 
                    color: isOwned ? "#f39c12" : "#f8c471", 
                    fontSize: 13,
                    marginBottom: 4,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}>
                    <span>{ability.name}</span>
                    <span style={{ fontSize: 11, color: "#8a7e5e" }}>{ABILITY_COST} EXP</span>
                  </div>
                  <p style={{ color: "#a09070", fontSize: 11, marginBottom: 8, lineHeight: 1.4 }}>
                    {ability.desc}
                  </p>
                  <button
                    onClick={() => canBuy && purchaseAlchemyAbility(3, ability.id)}
                    disabled={!canBuy}
                    style={{
                      ...btnStyle(isOwned ? "#f39c12" : "#f8c471", isOwned ? "rgba(243,156,18,0.2)" : "rgba(243,156,18,0.1)"),
                      padding: "6px 12px",
                      width: "100%",
                      cursor: canBuy ? "pointer" : "not-allowed",
                      opacity: canBuy || isOwned ? 1 : 0.5
                    }}
                  >
                    {isOwned ? "✓ Owned" : !alchemyTier3Unlocked ? "Locked" : "Buy"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
        </>
        )}
      </div>

      {/* Might Tier Abilities */}
      <div style={{
        background: "rgba(20,16,10,0.6)",
        border: "1px solid rgba(192,57,43,0.3)",
        borderRadius: 8,
        padding: 20,
        marginBottom: 24
      }}>
        <div 
          onClick={() => toggleSection('might')}
          style={{ 
            cursor: "pointer", 
            display: "flex", 
            justifyContent: "space-between", 
            alignItems: "center",
            marginBottom: expandedSections.might ? 16 : 0
          }}
        >
          <div>
            <h3 style={{ color: "#c0392b", marginBottom: 4, fontSize: 18 }}>Might Abilities</h3>
            <p style={{ color: "#8a7e5e", fontSize: 12 }}>
              Requires Might stat at specified level + skill prerequisites • Uses Universal or Might EXP
            </p>
          </div>
          <span style={{ color: "#c0392b", fontSize: 24 }}>
            {expandedSections.might ? "−" : "+"}
          </span>
        </div>

        {expandedSections.might && (
          <>

        {/* Might Tier 1 */}
        <div style={{ marginBottom: 20 }}>
          <div style={{
            color: character.stats.might >= 20 ? "#c0392b" : "#6b6048",
            fontSize: 14,
            marginBottom: 12,
            display: "flex",
            alignItems: "center",
            gap: 8
          }}>
            <span>Tier 1 (Might 20+)</span>
            {character.stats.might < 20 && <span style={{ fontSize: 11, color: "#c0392b" }}>(Locked)</span>}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
            {STAT_TIER_ABILITIES.might.tier1.options.map(ability => {
              const isOwned = character.tierAbilities.mightTier1.includes(ability.id);
              const meetsStatReq = character.stats.might >= 20;
              const meetsSkillReq = hasSkillPrerequisite(ability.prerequisite);
              const canAfford = expPools.universal >= ABILITY_COST || expPools.might >= ABILITY_COST;
              const canBuy = meetsStatReq && meetsSkillReq && !isOwned && canAfford;

              return (
                <div key={ability.id} style={{
                  background: isOwned ? "rgba(192,57,43,0.15)" : "rgba(0,0,0,0.3)",
                  border: isOwned ? "1px solid #c0392b" : "1px solid rgba(192,57,43,0.2)",
                  borderRadius: 6,
                  padding: 12
                }}>
                  <div style={{ 
                    color: isOwned ? "#c0392b" : "#e74c3c", 
                    fontSize: 13,
                    marginBottom: 4,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}>
                    <span>{ability.name}</span>
                    <span style={{ fontSize: 11, color: "#8a7e5e" }}>{ABILITY_COST} EXP</span>
                  </div>
                  {ability.prerequisite && (
                    <div style={{ 
                      fontSize: 10, 
                      color: meetsSkillReq ? "#8a7e5e" : "#c0392b",
                      marginBottom: 4,
                      fontStyle: "italic"
                    }}>
                      {ability.prerequisite}
                    </div>
                  )}
                  <p style={{ color: "#a09070", fontSize: 11, marginBottom: 8, lineHeight: 1.4 }}>
                    {ability.desc}
                  </p>
                  <button
                    onClick={() => canBuy && purchaseStatAbility('might', 1, ability.id)}
                    disabled={!canBuy}
                    style={{
                      ...btnStyle(isOwned ? "#c0392b" : "#e74c3c", isOwned ? "rgba(192,57,43,0.2)" : "rgba(192,57,43,0.1)"),
                      padding: "6px 12px",
                      width: "100%",
                      cursor: canBuy ? "pointer" : "not-allowed",
                      opacity: canBuy || isOwned ? 1 : 0.5
                    }}
                  >
                    {isOwned ? "✓ Owned" : !meetsStatReq ? "Locked" : !meetsSkillReq ? "Need Skills" : "Buy"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* Might Tier 2 */}
        <div style={{ marginBottom: 20 }}>
          <div style={{
            color: character.stats.might >= 30 ? "#c0392b" : "#6b6048",
            fontSize: 14,
            marginBottom: 12,
            display: "flex",
            alignItems: "center",
            gap: 8
          }}>
            <span>Tier 2 (Might 30+)</span>
            {character.stats.might < 30 && <span style={{ fontSize: 11, color: "#c0392b" }}>(Locked)</span>}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
            {STAT_TIER_ABILITIES.might.tier2.options.map(ability => {
              const isOwned = character.tierAbilities.mightTier2.includes(ability.id);
              const meetsStatReq = character.stats.might >= 30;
              const meetsSkillReq = hasSkillPrerequisite(ability.prerequisite);
              const canAfford = expPools.universal >= ABILITY_COST || expPools.might >= ABILITY_COST;
              const canBuy = meetsStatReq && meetsSkillReq && !isOwned && canAfford;

              return (
                <div key={ability.id} style={{
                  background: isOwned ? "rgba(192,57,43,0.15)" : "rgba(0,0,0,0.3)",
                  border: isOwned ? "1px solid #c0392b" : "1px solid rgba(192,57,43,0.2)",
                  borderRadius: 6,
                  padding: 12
                }}>
                  <div style={{ 
                    color: isOwned ? "#c0392b" : "#e74c3c", 
                    fontSize: 13,
                    marginBottom: 4,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}>
                    <span>{ability.name}</span>
                    <span style={{ fontSize: 11, color: "#8a7e5e" }}>{ABILITY_COST} EXP</span>
                  </div>
                  {ability.prerequisite && (
                    <div style={{ 
                      fontSize: 10, 
                      color: meetsSkillReq ? "#8a7e5e" : "#c0392b",
                      marginBottom: 4,
                      fontStyle: "italic"
                    }}>
                      {ability.prerequisite}
                    </div>
                  )}
                  <p style={{ color: "#a09070", fontSize: 11, marginBottom: 8, lineHeight: 1.4 }}>
                    {ability.desc}
                  </p>
                  <button
                    onClick={() => canBuy && purchaseStatAbility('might', 2, ability.id)}
                    disabled={!canBuy}
                    style={{
                      ...btnStyle(isOwned ? "#c0392b" : "#e74c3c", isOwned ? "rgba(192,57,43,0.2)" : "rgba(192,57,43,0.1)"),
                      padding: "6px 12px",
                      width: "100%",
                      cursor: canBuy ? "pointer" : "not-allowed",
                      opacity: canBuy || isOwned ? 1 : 0.5
                    }}
                  >
                    {isOwned ? "✓ Owned" : !meetsStatReq ? "Locked" : !meetsSkillReq ? "Need Skills" : "Buy"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* Might Tier 3 */}
        <div>
          <div style={{
            color: character.stats.might >= 50 ? "#c0392b" : "#6b6048",
            fontSize: 14,
            marginBottom: 12,
            display: "flex",
            alignItems: "center",
            gap: 8
          }}>
            <span>Tier 3 (Might 50)</span>
            {character.stats.might < 50 && <span style={{ fontSize: 11, color: "#c0392b" }}>(Locked)</span>}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
            {STAT_TIER_ABILITIES.might.tier3.options.map(ability => {
              const isOwned = character.tierAbilities.mightTier3.includes(ability.id);
              const meetsStatReq = character.stats.might >= 50;
              const meetsAbilityReq = hasAbilityPrerequisite('might', 3, ability.prerequisite);
              const canAfford = expPools.universal >= ABILITY_COST || expPools.might >= ABILITY_COST;
              const canBuy = meetsStatReq && meetsAbilityReq && !isOwned && canAfford;

              return (
                <div key={ability.id} style={{
                  background: isOwned ? "rgba(192,57,43,0.15)" : "rgba(0,0,0,0.3)",
                  border: isOwned ? "1px solid #c0392b" : "1px solid rgba(192,57,43,0.2)",
                  borderRadius: 6,
                  padding: 12
                }}>
                  <div style={{ 
                    color: isOwned ? "#c0392b" : "#e74c3c", 
                    fontSize: 13,
                    marginBottom: 4,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}>
                    <span>{ability.name}</span>
                    <span style={{ fontSize: 11, color: "#8a7e5e" }}>{ABILITY_COST} EXP</span>
                  </div>
                  {ability.prerequisite && (
                    <div style={{ 
                      fontSize: 10, 
                      color: meetsAbilityReq ? "#8a7e5e" : "#c0392b",
                      marginBottom: 4,
                      fontStyle: "italic"
                    }}>
                      Requires: {ability.prerequisite}
                    </div>
                  )}
                  <p style={{ color: "#a09070", fontSize: 11, marginBottom: 8, lineHeight: 1.4 }}>
                    {ability.desc}
                  </p>
                  <button
                    onClick={() => canBuy && purchaseStatAbility('might', 3, ability.id)}
                    disabled={!canBuy}
                    style={{
                      ...btnStyle(isOwned ? "#c0392b" : "#e74c3c", isOwned ? "rgba(192,57,43,0.2)" : "rgba(192,57,43,0.1)"),
                      padding: "6px 12px",
                      width: "100%",
                      cursor: canBuy ? "pointer" : "not-allowed",
                      opacity: canBuy || isOwned ? 1 : 0.5
                    }}
                  >
                    {isOwned ? "✓ Owned" : !meetsStatReq ? "Locked" : !meetsAbilityReq ? "Need Ability" : "Buy"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
        </>
        )}
      </div>

      {/* Speed Tier Abilities */}
      <div style={{
        background: "rgba(20,16,10,0.6)",
        border: "1px solid rgba(41,128,185,0.3)",
        borderRadius: 8,
        padding: 20,
        marginBottom: 24
      }}>
        <div 
          onClick={() => toggleSection('speed')}
          style={{ 
            cursor: "pointer", 
            display: "flex", 
            justifyContent: "space-between", 
            alignItems: "center",
            marginBottom: expandedSections.speed ? 16 : 0
          }}
        >
          <div>
            <h3 style={{ color: "#2980b9", marginBottom: 4, fontSize: 18 }}>Speed Abilities</h3>
            <p style={{ color: "#8a7e5e", fontSize: 12 }}>
              Requires Speed stat at specified level + skill prerequisites • Uses Universal or Speed EXP
            </p>
          </div>
          <span style={{ color: "#2980b9", fontSize: 24 }}>
            {expandedSections.speed ? "−" : "+"}
          </span>
        </div>

        {expandedSections.speed && (
          <>

        {/* Speed Tier 1 */}
        <div style={{ marginBottom: 20 }}>
          <div style={{
            color: character.stats.speed >= 20 ? "#2980b9" : "#6b6048",
            fontSize: 14,
            marginBottom: 12,
            display: "flex",
            alignItems: "center",
            gap: 8
          }}>
            <span>Tier 1 (Speed 20+)</span>
            {character.stats.speed < 20 && <span style={{ fontSize: 11, color: "#c0392b" }}>(Locked)</span>}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
            {STAT_TIER_ABILITIES.speed.tier1.options.map(ability => {
              const isOwned = character.tierAbilities.speedTier1.includes(ability.id);
              const meetsStatReq = character.stats.speed >= 20;
              const meetsSkillReq = hasSkillPrerequisite(ability.prerequisite);
              const canAfford = expPools.universal >= ABILITY_COST || expPools.speed >= ABILITY_COST;
              const canBuy = meetsStatReq && meetsSkillReq && !isOwned && canAfford;

              return (
                <div key={ability.id} style={{
                  background: isOwned ? "rgba(41,128,185,0.15)" : "rgba(0,0,0,0.3)",
                  border: isOwned ? "1px solid #2980b9" : "1px solid rgba(41,128,185,0.2)",
                  borderRadius: 6,
                  padding: 12
                }}>
                  <div style={{ 
                    color: isOwned ? "#2980b9" : "#5dade2", 
                    fontSize: 13,
                    marginBottom: 4,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}>
                    <span>{ability.name}</span>
                    <span style={{ fontSize: 11, color: "#8a7e5e" }}>{ABILITY_COST} EXP</span>
                  </div>
                  {ability.prerequisite && (
                    <div style={{ 
                      fontSize: 10, 
                      color: meetsSkillReq ? "#8a7e5e" : "#c0392b",
                      marginBottom: 4,
                      fontStyle: "italic"
                    }}>
                      {ability.prerequisite}
                    </div>
                  )}
                  <p style={{ color: "#a09070", fontSize: 11, marginBottom: 8, lineHeight: 1.4 }}>
                    {ability.desc}
                  </p>
                  <button
                    onClick={() => canBuy && purchaseStatAbility('speed', 1, ability.id)}
                    disabled={!canBuy}
                    style={{
                      ...btnStyle(isOwned ? "#2980b9" : "#5dade2", isOwned ? "rgba(41,128,185,0.2)" : "rgba(41,128,185,0.1)"),
                      padding: "6px 12px",
                      width: "100%",
                      cursor: canBuy ? "pointer" : "not-allowed",
                      opacity: canBuy || isOwned ? 1 : 0.5
                    }}
                  >
                    {isOwned ? "✓ Owned" : !meetsStatReq ? "Locked" : !meetsSkillReq ? "Need Skills" : "Buy"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* Speed Tier 2 */}
        <div style={{ marginBottom: 20 }}>
          <div style={{
            color: character.stats.speed >= 30 ? "#2980b9" : "#6b6048",
            fontSize: 14,
            marginBottom: 12,
            display: "flex",
            alignItems: "center",
            gap: 8
          }}>
            <span>Tier 2 (Speed 30+)</span>
            {character.stats.speed < 30 && <span style={{ fontSize: 11, color: "#c0392b" }}>(Locked)</span>}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
            {STAT_TIER_ABILITIES.speed.tier2.options.map(ability => {
              const isOwned = character.tierAbilities.speedTier2.includes(ability.id);
              const meetsStatReq = character.stats.speed >= 30;
              const meetsSkillReq = hasSkillPrerequisite(ability.prerequisite);
              const canAfford = expPools.universal >= ABILITY_COST || expPools.speed >= ABILITY_COST;
              const canBuy = meetsStatReq && meetsSkillReq && !isOwned && canAfford;

              return (
                <div key={ability.id} style={{
                  background: isOwned ? "rgba(41,128,185,0.15)" : "rgba(0,0,0,0.3)",
                  border: isOwned ? "1px solid #2980b9" : "1px solid rgba(41,128,185,0.2)",
                  borderRadius: 6,
                  padding: 12
                }}>
                  <div style={{ 
                    color: isOwned ? "#2980b9" : "#5dade2", 
                    fontSize: 13,
                    marginBottom: 4,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}>
                    <span>{ability.name}</span>
                    <span style={{ fontSize: 11, color: "#8a7e5e" }}>{ABILITY_COST} EXP</span>
                  </div>
                  {ability.prerequisite && (
                    <div style={{ 
                      fontSize: 10, 
                      color: meetsSkillReq ? "#8a7e5e" : "#c0392b",
                      marginBottom: 4,
                      fontStyle: "italic"
                    }}>
                      {ability.prerequisite}
                    </div>
                  )}
                  <p style={{ color: "#a09070", fontSize: 11, marginBottom: 8, lineHeight: 1.4 }}>
                    {ability.desc}
                  </p>
                  <button
                    onClick={() => canBuy && purchaseStatAbility('speed', 2, ability.id)}
                    disabled={!canBuy}
                    style={{
                      ...btnStyle(isOwned ? "#2980b9" : "#5dade2", isOwned ? "rgba(41,128,185,0.2)" : "rgba(41,128,185,0.1)"),
                      padding: "6px 12px",
                      width: "100%",
                      cursor: canBuy ? "pointer" : "not-allowed",
                      opacity: canBuy || isOwned ? 1 : 0.5
                    }}
                  >
                    {isOwned ? "✓ Owned" : !meetsStatReq ? "Locked" : !meetsSkillReq ? "Need Skills" : "Buy"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* Speed Tier 3 */}
        <div>
          <div style={{
            color: character.stats.speed >= 50 ? "#2980b9" : "#6b6048",
            fontSize: 14,
            marginBottom: 12,
            display: "flex",
            alignItems: "center",
            gap: 8
          }}>
            <span>Tier 3 (Speed 50)</span>
            {character.stats.speed < 50 && <span style={{ fontSize: 11, color: "#c0392b" }}>(Locked)</span>}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
            {STAT_TIER_ABILITIES.speed.tier3.options.map(ability => {
              const isOwned = character.tierAbilities.speedTier3.includes(ability.id);
              const meetsStatReq = character.stats.speed >= 50;
              const meetsAbilityReq = hasAbilityPrerequisite('speed', 3, ability.prerequisite);
              const canAfford = expPools.universal >= ABILITY_COST || expPools.speed >= ABILITY_COST;
              const canBuy = meetsStatReq && meetsAbilityReq && !isOwned && canAfford;

              return (
                <div key={ability.id} style={{
                  background: isOwned ? "rgba(41,128,185,0.15)" : "rgba(0,0,0,0.3)",
                  border: isOwned ? "1px solid #2980b9" : "1px solid rgba(41,128,185,0.2)",
                  borderRadius: 6,
                  padding: 12
                }}>
                  <div style={{ 
                    color: isOwned ? "#2980b9" : "#5dade2", 
                    fontSize: 13,
                    marginBottom: 4,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}>
                    <span>{ability.name}</span>
                    <span style={{ fontSize: 11, color: "#8a7e5e" }}>{ABILITY_COST} EXP</span>
                  </div>
                  {ability.prerequisite && (
                    <div style={{ 
                      fontSize: 10, 
                      color: meetsAbilityReq ? "#8a7e5e" : "#c0392b",
                      marginBottom: 4,
                      fontStyle: "italic"
                    }}>
                      Requires: {ability.prerequisite}
                    </div>
                  )}
                  <p style={{ color: "#a09070", fontSize: 11, marginBottom: 8, lineHeight: 1.4 }}>
                    {ability.desc}
                  </p>
                  <button
                    onClick={() => canBuy && purchaseStatAbility('speed', 3, ability.id)}
                    disabled={!canBuy}
                    style={{
                      ...btnStyle(isOwned ? "#2980b9" : "#5dade2", isOwned ? "rgba(41,128,185,0.2)" : "rgba(41,128,185,0.1)"),
                      padding: "6px 12px",
                      width: "100%",
                      cursor: canBuy ? "pointer" : "not-allowed",
                      opacity: canBuy || isOwned ? 1 : 0.5
                    }}
                  >
                    {isOwned ? "✓ Owned" : !meetsStatReq ? "Locked" : !meetsAbilityReq ? "Need Ability" : "Buy"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
        </>
        )}
      </div>

      {/* Intellect Tier Abilities */}
      <div style={{
        background: "rgba(20,16,10,0.6)",
        border: "1px solid rgba(142,68,173,0.3)",
        borderRadius: 8,
        padding: 20
      }}>
        <div 
          onClick={() => toggleSection('intellect')}
          style={{ 
            cursor: "pointer", 
            display: "flex", 
            justifyContent: "space-between", 
            alignItems: "center",
            marginBottom: expandedSections.intellect ? 16 : 0
          }}
        >
          <div>
            <h3 style={{ color: "#8e44ad", marginBottom: 4, fontSize: 18 }}>Intellect Abilities</h3>
            <p style={{ color: "#8a7e5e", fontSize: 12 }}>
              Requires Intellect stat at specified level + skill prerequisites • Uses Universal or Intellect EXP
            </p>
          </div>
          <span style={{ color: "#8e44ad", fontSize: 24 }}>
            {expandedSections.intellect ? "−" : "+"}
          </span>
        </div>

        {expandedSections.intellect && (
          <>

        {/* Intellect Tier 1 */}
        <div style={{ marginBottom: 20 }}>
          <div style={{
            color: character.stats.intellect >= 20 ? "#8e44ad" : "#6b6048",
            fontSize: 14,
            marginBottom: 12,
            display: "flex",
            alignItems: "center",
            gap: 8
          }}>
            <span>Tier 1 (Intellect 20+)</span>
            {character.stats.intellect < 20 && <span style={{ fontSize: 11, color: "#c0392b" }}>(Locked)</span>}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
            {STAT_TIER_ABILITIES.intellect.tier1.options.map(ability => {
              const isOwned = character.tierAbilities.intellectTier1.includes(ability.id);
              const meetsStatReq = character.stats.intellect >= 20;
              const meetsSkillReq = hasSkillPrerequisite(ability.prerequisite);
              const canAfford = expPools.universal >= ABILITY_COST || expPools.intellect >= ABILITY_COST;
              const canBuy = meetsStatReq && meetsSkillReq && !isOwned && canAfford;

              return (
                <div key={ability.id} style={{
                  background: isOwned ? "rgba(142,68,173,0.15)" : "rgba(0,0,0,0.3)",
                  border: isOwned ? "1px solid #8e44ad" : "1px solid rgba(142,68,173,0.2)",
                  borderRadius: 6,
                  padding: 12
                }}>
                  <div style={{ 
                    color: isOwned ? "#8e44ad" : "#c39bd3", 
                    fontSize: 13,
                    marginBottom: 4,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}>
                    <span>{ability.name}</span>
                    <span style={{ fontSize: 11, color: "#8a7e5e" }}>{ABILITY_COST} EXP</span>
                  </div>
                  {ability.prerequisite && (
                    <div style={{ 
                      fontSize: 10, 
                      color: meetsSkillReq ? "#8a7e5e" : "#c0392b",
                      marginBottom: 4,
                      fontStyle: "italic"
                    }}>
                      {ability.prerequisite}
                    </div>
                  )}
                  <p style={{ color: "#a09070", fontSize: 11, marginBottom: 8, lineHeight: 1.4 }}>
                    {ability.desc}
                  </p>
                  <button
                    onClick={() => canBuy && purchaseStatAbility('intellect', 1, ability.id)}
                    disabled={!canBuy}
                    style={{
                      ...btnStyle(isOwned ? "#8e44ad" : "#c39bd3", isOwned ? "rgba(142,68,173,0.2)" : "rgba(142,68,173,0.1)"),
                      padding: "6px 12px",
                      width: "100%",
                      cursor: canBuy ? "pointer" : "not-allowed",
                      opacity: canBuy || isOwned ? 1 : 0.5
                    }}
                  >
                    {isOwned ? "✓ Owned" : !meetsStatReq ? "Locked" : !meetsSkillReq ? "Need Skills" : "Buy"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* Intellect Tier 2 */}
        <div style={{ marginBottom: 20 }}>
          <div style={{
            color: character.stats.intellect >= 30 ? "#8e44ad" : "#6b6048",
            fontSize: 14,
            marginBottom: 12,
            display: "flex",
            alignItems: "center",
            gap: 8
          }}>
            <span>Tier 2 (Intellect 30+)</span>
            {character.stats.intellect < 30 && <span style={{ fontSize: 11, color: "#c0392b" }}>(Locked)</span>}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
            {STAT_TIER_ABILITIES.intellect.tier2.options.map(ability => {
              const isOwned = character.tierAbilities.intellectTier2.includes(ability.id);
              const meetsStatReq = character.stats.intellect >= 30;
              const meetsSkillReq = hasSkillPrerequisite(ability.prerequisite);
              const canAfford = expPools.universal >= ABILITY_COST || expPools.intellect >= ABILITY_COST;
              const canBuy = meetsStatReq && meetsSkillReq && !isOwned && canAfford;

              return (
                <div key={ability.id} style={{
                  background: isOwned ? "rgba(142,68,173,0.15)" : "rgba(0,0,0,0.3)",
                  border: isOwned ? "1px solid #8e44ad" : "1px solid rgba(142,68,173,0.2)",
                  borderRadius: 6,
                  padding: 12
                }}>
                  <div style={{ 
                    color: isOwned ? "#8e44ad" : "#c39bd3", 
                    fontSize: 13,
                    marginBottom: 4,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}>
                    <span>{ability.name}</span>
                    <span style={{ fontSize: 11, color: "#8a7e5e" }}>{ABILITY_COST} EXP</span>
                  </div>
                  {ability.prerequisite && (
                    <div style={{ 
                      fontSize: 10, 
                      color: meetsSkillReq ? "#8a7e5e" : "#c0392b",
                      marginBottom: 4,
                      fontStyle: "italic"
                    }}>
                      {ability.prerequisite}
                    </div>
                  )}
                  <p style={{ color: "#a09070", fontSize: 11, marginBottom: 8, lineHeight: 1.4 }}>
                    {ability.desc}
                  </p>
                  <button
                    onClick={() => canBuy && purchaseStatAbility('intellect', 2, ability.id)}
                    disabled={!canBuy}
                    style={{
                      ...btnStyle(isOwned ? "#8e44ad" : "#c39bd3", isOwned ? "rgba(142,68,173,0.2)" : "rgba(142,68,173,0.1)"),
                      padding: "6px 12px",
                      width: "100%",
                      cursor: canBuy ? "pointer" : "not-allowed",
                      opacity: canBuy || isOwned ? 1 : 0.5
                    }}
                  >
                    {isOwned ? "✓ Owned" : !meetsStatReq ? "Locked" : !meetsSkillReq ? "Need Skills" : "Buy"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* Intellect Tier 3 */}
        <div>
          <div style={{
            color: character.stats.intellect >= 50 ? "#8e44ad" : "#6b6048",
            fontSize: 14,
            marginBottom: 12,
            display: "flex",
            alignItems: "center",
            gap: 8
          }}>
            <span>Tier 3 (Intellect 50)</span>
            {character.stats.intellect < 50 && <span style={{ fontSize: 11, color: "#c0392b" }}>(Locked)</span>}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
            {STAT_TIER_ABILITIES.intellect.tier3.options.map(ability => {
              const isOwned = character.tierAbilities.intellectTier3.includes(ability.id);
              const meetsStatReq = character.stats.intellect >= 50;
              const meetsAbilityReq = hasAbilityPrerequisite('intellect', 3, ability.prerequisite);
              const canAfford = expPools.universal >= ABILITY_COST || expPools.intellect >= ABILITY_COST;
              const canBuy = meetsStatReq && meetsAbilityReq && !isOwned && canAfford;

              return (
                <div key={ability.id} style={{
                  background: isOwned ? "rgba(142,68,173,0.15)" : "rgba(0,0,0,0.3)",
                  border: isOwned ? "1px solid #8e44ad" : "1px solid rgba(142,68,173,0.2)",
                  borderRadius: 6,
                  padding: 12
                }}>
                  <div style={{ 
                    color: isOwned ? "#8e44ad" : "#c39bd3", 
                    fontSize: 13,
                    marginBottom: 4,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}>
                    <span>{ability.name}</span>
                    <span style={{ fontSize: 11, color: "#8a7e5e" }}>{ABILITY_COST} EXP</span>
                  </div>
                  {ability.prerequisite && (
                    <div style={{ 
                      fontSize: 10, 
                      color: meetsAbilityReq ? "#8a7e5e" : "#c0392b",
                      marginBottom: 4,
                      fontStyle: "italic"
                    }}>
                      Requires: {ability.prerequisite}
                    </div>
                  )}
                  <p style={{ color: "#a09070", fontSize: 11, marginBottom: 8, lineHeight: 1.4 }}>
                    {ability.desc}
                  </p>
                  <button
                    onClick={() => canBuy && purchaseStatAbility('intellect', 3, ability.id)}
                    disabled={!canBuy}
                    style={{
                      ...btnStyle(isOwned ? "#8e44ad" : "#c39bd3", isOwned ? "rgba(142,68,173,0.2)" : "rgba(142,68,173,0.1)"),
                      padding: "6px 12px",
                      width: "100%",
                      cursor: canBuy ? "pointer" : "not-allowed",
                      opacity: canBuy || isOwned ? 1 : 0.5
                    }}
                  >
                    {isOwned ? "✓ Owned" : !meetsStatReq ? "Locked" : !meetsAbilityReq ? "Need Ability" : "Buy"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
        </>
        )}
      </div>
    </div>
  );
}
